export default "__VITE_PUBLIC_ASSET__ccb4a435__"